import { RouteLocationNormalized } from 'vue-router'

interface Result {
  guid: string
}

export function followMeEditScriptPropsFn (to: RouteLocationNormalized): Result {
  const { id } = to.params
  let guid

  if (Array.isArray(id)) {
    guid = id[0]
  } else {
    guid = id
  }

  return {
    guid: guid!,
  }
}
